import { Ufs } from "./enums/uf-enum";

export class EleitorCsvDTO  {

    constructor(
        public login?: string,
        public email?: string,
        public senha?: string,
        public auth1?: string,
        public auth2?: string,
        public plano?:string, 
        public estado?: string,
        public agrupador?: string,  
        

    ) {}
 
}